import { Icon, type IconName } from './Icon';
import styles from './StatTile.module.css';

type Accent = 'brand' | 'gold' | 'mint' | 'rose' | 'cyan';

interface StatTileProps {
  icon: IconName;
  label: string;
  value: string;
  hint?: string;
  accent?: Accent;
}

export function StatTile({ icon, label, value, hint, accent = 'brand' }: StatTileProps) {
  return (
    <div className={`${styles.tile} ${styles[accent]}`}>
      <span className={styles.glow} style={{ background: 'currentColor' }} />
      <span className={styles.iconWrap}>
        <Icon name={icon} size={22} />
      </span>
      <div className={styles.body}>
        <span className={styles.label}>{label}</span>
        <span className={styles.value}>{value}</span>
        {hint && <span className={styles.hint}>{hint}</span>}
      </div>
    </div>
  );
}
